import { NgModule } from "@angular/core";
import { IbanFormatPipe } from "@modules/core/pipes/iban.format.pipe";
import {
	FiatPrecisionSymbolPipe,
	TradablePrecisionSymbolPipe
} from "@modules/core/pipes/currency.symbol.precision.pipe";
import {
	ConvertTradableToFiatConversionPipe,
	ConvertTradableToFiatDynamicPipe,
	ConvertTradableToFiatPipe
} from "@modules/core/pipes/tradable-to-fiat.pipe";
import {
	ConvertFiatToTradableDynamicPipe,
	ConvertFiatToTradablePipe,
	FiatExistsCheckPipe
} from "@modules/core/pipes/fiat-to-tradable.pipe";
import { BpDatePipe, DateFromNow, DateIsoFormat, DateLocalePipe } from "@modules/core/pipes/date.pipe";
import { CapitalizePipe } from "@modules/core/pipes/capitalize.pipe";
import {
	FiatLocaleFormatPipe,
	FiatPrecisionPipe,
	FourEightTradablePrecisionPipe,
	LocalFormatPipe,
	LocalFormatResetPipe,
	TradablePrecisionPipe
} from "@modules/core/pipes/currency.precision.pipe";
import {
	AccessFiatSymbolPipe,
	AccessTradableSymbolPipe,
	FiatSymbolPipe,
	TradableSymbolPipe
} from "@modules/core/pipes/currency.symbol.pipe";
import { FiatNamePipe, TradableNamePipe } from "@modules/core/pipes/currency.name.pipe";
import { VoucherPipe } from "@modules/core/pipes/voucher.pipe";
import { TradableByPidPipe, TradablePipe } from "@modules/core/pipes/tradable.pipe";
import { ContactSearchPipe } from "@modules/core/pipes/contact-search.pipe";
import { HighlightSearch } from "@modules/core/pipes/highlight-search.pipe";
import { HasWalletPipe } from "@modules/core/pipes/has-wallet.pipe";
import { LargeNumberPipe } from "@modules/core/pipes/large-number.pipe";
import { LanguageToIsoCodePipe } from "@modules/core/pipes/language-to-isocode.pipe";
import { ValueChangePrefixPipe } from "@modules/core/pipes/value-change.pipe";
import { PercentSymbolPipe } from "@modules/core/pipes/percent-symbol.pipe";
import { TruncateFixedPipe } from "@modules/core/pipes/truncate-fixed.pipe";
import { HideNumberPrefixPipe } from "@modules/core/pipes/hide-number-prefix.pipe";
import { HideEmailPipe } from "@modules/core/pipes/hide-email.pipe";
import { SignChangePipe } from "@modules/core/pipes/sign-change.pipe";
import { AbsolutePipe, NegativeToZeroPipe } from "@modules/core/pipes/absolute.pipe";
import { PercentSymbolPrecisionPipe } from "@modules/core/pipes/percent-symbol-precision.pipe";
import { ConvertFiatToDefaultFiat, EuroToUserFiatPipe } from "@modules/core/pipes/euro-to-user-fiat.pipe";
import { UserFiatToEuroPipe } from "@modules/core/pipes/user-fiat-to-euro.pipe";
import { SortCodeFormatPipe } from "@modules/core/pipes/sort-code.format.pipe";
import { AddNumberPrefixPipe } from "@modules/core/pipes/add-number-prefix.pipe";
import { ToFixedPipe, ToFixedRoundPipe } from "@modules/core/pipes/to-fixed.pipe";
import { FileSizeFormatPipe } from "@modules/core/pipes/file-size-format.pipe";
import { EffectiveLeverageTokenPipe } from "@modules/core/pipes/leverage-token.pipe";
import { CountdownFormatPipe } from "@modules/core/pipes/countdown-format.pipe";
import { CountdownCustomFormatPipe } from "@modules/core/pipes/countdown-custom-format.pipe";
import { NumberNativePipe } from "@modules/core/pipes/number-native.pipe";
import { DateNativePipe } from "@modules/core/pipes/date-native.pipe";
import { PriceChangePercentPipe } from "@modules/core/pipes/prices/price-change-percent.pipe";
import { ChartLineColorPipe } from "@modules/core/pipes/chart-color.pipe";
import { ChangePrefixIconPipe } from "@modules/core/pipes/change-prefix-icon.pipe";
import { ChangePrefixColorPipe } from "@modules/core/pipes/change-prefix-color.pipe";
import {
	RoundingPipe,
	RoundingUpForMinValFiat,
	RoundingUpMinVal,
	RoundingWithPrecisionPipe
} from "@modules/core/pipes/rounding.pipe";
import { NumberLessThanPipe, NumberMoreThanTwoDecimalsPipe } from "@modules/core/pipes/number-less-than.pipe";
import { SecurityTokenUnitPipe } from "@modules/core/pipes/security.token.unit.pipe";
import { MarkdownPipe } from "@modules/core/pipes/markdown-pipe";
import { TcLinkReplacePipe } from "@modules/core/pipes/tc-link-replace.pipe";
import { PercentagePrecisionPipe } from "./percent-precision.pipe";
import { UnitValueDisplayPipe } from "./unit-value.pipe";
import { IncludeGenericPipe } from "./include.pipe";

const pipes = [
	IbanFormatPipe,
	TradablePrecisionSymbolPipe,
	ConvertTradableToFiatPipe,
	ConvertTradableToFiatDynamicPipe,
	ConvertTradableToFiatConversionPipe,
	ConvertFiatToTradablePipe,
	ConvertFiatToTradableDynamicPipe,
	FiatExistsCheckPipe,
	FiatPrecisionSymbolPipe,
	BpDatePipe,
	DateFromNow,
	DateLocalePipe,
	DateIsoFormat,
	CapitalizePipe,
	TradablePrecisionPipe,
	FourEightTradablePrecisionPipe,
	TradableSymbolPipe,
	FiatNamePipe,
	FiatPrecisionPipe,
	FiatSymbolPipe,
	LocalFormatPipe,
	LocalFormatResetPipe,
	FiatLocaleFormatPipe,
	AccessFiatSymbolPipe,
	AccessTradableSymbolPipe,
	TradableNamePipe,
	VoucherPipe,
	TradablePipe,
	TradableByPidPipe,
	ContactSearchPipe,
	HighlightSearch,
	HasWalletPipe,
	LargeNumberPipe,
	LanguageToIsoCodePipe,
	ValueChangePrefixPipe,
	PercentSymbolPipe,
	TruncateFixedPipe,
	HideNumberPrefixPipe,
	HideEmailPipe,
	SignChangePipe,
	AbsolutePipe,
	NegativeToZeroPipe,
	PercentSymbolPrecisionPipe,
	EuroToUserFiatPipe,
	ConvertFiatToDefaultFiat,
	UserFiatToEuroPipe,
	SortCodeFormatPipe,
	AddNumberPrefixPipe,
	ToFixedPipe,
	ToFixedRoundPipe,
	FileSizeFormatPipe,
	EffectiveLeverageTokenPipe,
	CountdownFormatPipe,
	CountdownCustomFormatPipe,
	NumberNativePipe,
	DateNativePipe,
	PriceChangePercentPipe,
	ChartLineColorPipe,
	ChangePrefixIconPipe,
	ChangePrefixColorPipe,
	RoundingPipe,
	RoundingWithPrecisionPipe,
	RoundingUpForMinValFiat,
	RoundingUpMinVal,
	NumberLessThanPipe,
	NumberMoreThanTwoDecimalsPipe,
	SecurityTokenUnitPipe,
	MarkdownPipe,
	TcLinkReplacePipe,
	PercentagePrecisionPipe,
	UnitValueDisplayPipe,
	IncludeGenericPipe
];

@NgModule({
	declarations: [pipes],
	exports: pipes,
	providers: [FiatPrecisionSymbolPipe, PercentSymbolPipe, ConvertFiatToTradablePipe]
})
export class PipeModule {}
